<template>
  <div class="navbar">
    <hamburger
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />
    
    <div class="right-menu">
      <div class="download">
        <i class="el-icon-download" @click="handleDownloadStatus"></i> 
      </div>
      <div class="avatar-wrapper">
        <el-dropdown @command="handleUserCommand">
          <span class="el-dropdown-link">
            Hi, {{ userInfo.name }}({{ userInfo.tcUcode }})<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- <img src="https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif?imageView2/1/w/80/h/80" class="user-avatar" /> -->
      </div>
    </div>
    
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Hamburger from "../Hamburger";

export default {
  name: "NavBar",
  components: {
    Hamburger,
  },
  computed: {
    ...mapGetters(["sidebar"]),
    ...mapState('user', {
      userInfo: state => state.userInfo,
    }),
    // userInfo() {
    //   console.log('usrInfor', window._userInfo_);
    //   return window._userInfo_;
    // }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    logout() {
      window.location.href= '/cooperator/authentication/logout';
    },
    handleDownloadStatus() {
      window._setGlobalState_({ downloadVisible: true });
    },
    handleUserCommand(command) {
      switch(command) {
        case 'logout':
          this.logout();
          break;
        default:
          break;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 3px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;
    &:hover {
      background: rgba(0, 0, 0, 0.03);
    }
  }


  .right-menu {
    display: flex;
    align-items: center;
    float: right;
    height: 100%;
    .download {
      margin-right: 15px;
    }
    // line-height: 50px;
    &:focus {
      outline: none;
    } 
      .avatar-wrapper {
        // margin-top: 5px;
        position: relative;
        margin-right: 30px;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }
    }
  }
}
</style>
